export enum InvestmentTypeEnum {
    Exchange = 1,
    Risk = 2,
    StructuredProducts = 3
}